export const getReturnUrl = () => {
  const params = (new URL(window.location)).searchParams;
  return params.get('returnUrl');
};
